export class BackupZeroEtlIcebergPartitionSpec {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "transforms",
            "baseName": "transforms",
            "type": "Array<BackupZeroEtlIcebergPartitionTransform>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlIcebergPartitionSpec.attributeTypeMap;
    }
    constructor() {
    }
}
